import { getEnv, getHostUrl, isTestEnv } from '@m2h/common/utils';
// import csb from '@cs/cs-bridge';
import createUpload from '@ai/mss-upload-js';
import request from '../../request';
import chooseImage from './chooseImage.h5';

interface ImageChoseItem {
  file: File;
  origin: File;
}

interface IUploadOptions {
  count?: number;
  path?: string;
  type?: string;
  visitId?: string;
  bucket?: string;
  localIds?: ImageChoseItem[];
  // localIds?: File[];
}

interface IUploadInfo {
  url: string;
  uploadPromise: Promise<string>;
  reUpload: () => Promise<string>;
}

interface IS3UploadSignResponse {
  signature: string;
  policy: string;
  key: string;
  awsaccessKeyId: string;
}

interface CSS3SignParams {
  type?: string;
  path?: string;
  visitId: string;
  bucketName?: string;
}

type ApiResult<T = any> = {
  success?: boolean;
  code: number;
  data: T;
  reason?: string | null;
  errMsg?: string;
  traceId?: string;
}

// export function getS3UploadSignV2(params: { path: string; }): Promise<ApiResult<IS3UploadSignResponse>> {
export function getS3UploadSignV2(params: CSS3SignParams): any {
  console.log('params');
  // const host = getHostUrl({ client: 'b', needProtocol: true, });
  const host = getHostUrl({ client: 'cs', needProtocol: true, });
  return request({
    url: `${host}/api/file/getS3UploadSignV2`,
    // url: '/api/file/getS3UploadSignV2',
    method: 'POST',
    data: params,
    headers: {
      visitId: 'test',
    },
    dataType: 'json',
  });
}

export function getVenusSign(params: CSS3SignParams): any {
  console.log('params');
  // const host = getHostUrl({ client: 'b', needProtocol: true, });
  // const host = getHostUrl({ client: 'm', needProtocol: true, });
  const host = getHostUrl({ client: 'c', needProtocol: true, });
  const bucketName = params.bucketName;
  return request({
    url: `${host}/api/v1/fpmigrate/image/sign${bucketName ? `?bucketName=${bucketName}` : ''}`,
    // url: `${host}/api/scm/customer/venus/sign?bucketName`,
    // url: `${host}/api/sailorProduct/customer/venus/sign`,
    method: 'POST',
    data: params,
    headers: {
      visitId: 'test',
    },
    dataType: 'json',
  });
}

let uploadPromise = Promise.resolve();

// 图片上传的执行间隔最小为 100ms，目前后端跟 S3 都存才问题，同时上传多个会有前后覆盖的问题
function invokeUploadWithInterval(fn: () => void) {
  uploadPromise = uploadPromise.then(() => {
    return new Promise((resolve) => {
      fn();

      setTimeout(() => {
        resolve();
      }, 100);
    });
  });
}

// 暂时用s3上传图片， bucket: sailorfe-c, 文件夹：images, 模拟bucket: sailorc等 业务传入，
function uploadImageByS3(file: File, options: IUploadOptions): Promise<string> {
  const env = getEnv();
  const { path = 'images/sailorc', visitId, bucket, } = options;
  console.log('uploadImageByS3 start', bucket, process_env_s3UploadHost);
  return new Promise((resolve, reject) => {
    invokeUploadWithInterval(() => {
      const uploadInstance = createUpload({
        signatureFunc: async () => {
          try {
            const params: any = { path, visitId };
            const fileType = file?.type?.split('/')?.[1];
            if (fileType) {
              params.type = `.${fileType}`;
            }
            const result = await getS3UploadSignV2(params);
            const {
              awsaccessKeyId, policy, signature, key
            } = result?.data || {};
            return {
              code: 0,
              message: 'success',
              data: {
                AWSAccessKeyId: awsaccessKeyId,
                policy,
                signature,
                key,
              },
            };
          } catch (error) {
            console.log('signatureFunc error', error);
            reject();
            // reportRaptor('【function】uploadInstance error', { error }, 'warn', 'customError');
            return null;
          }
        },
        authType: 'BAToken',
        // authType: 'muc',
        isHttps: true,
        multiple: false,
        networkEnv: 'public',
        // bucket: 'sailorfe-c',
        bucket: 'sailorfempcpublic',
        key: 'images/sailorc', // 上传后的文件名,文件名命名优先级顺序如下：服务端加签返回的key>用户传入key>文件本身名称仅单文件上传支持。
        prefix_type: 's3_style',
        file,
        isTest: !(['prod', 'st'].includes(env)),
        accept: ['png', 'jpg', 'jpeg'],
        s3_host: process_env_s3UploadHost,
        hashMode: true,
        // 临时，测试环境PC上传，先改为 false
        // exactKey: isTest ? false : true, // 上传的时候，不会带 . 和文件后缀名
        exactKey: true, // 上传的时候，不会带 . 和文件后缀名
        onStart(info: string) {
          console.log('imageuploadStart', info);
        },
        onSuccess(fileUrl: string) {
          console.log('imageupload onSuccess', fileUrl);
          resolve(fileUrl);
        },
        onError(errorMsg: string) {
          console.log('imageupload onError', errorMsg);
          reject(new Error(errorMsg));
        },
      }, 'venus'); // 值为1，单文件普通上传；值为2，单文件分片上传；值为3，多文件普通上传；值为venus，上传Venus
      console.log('uploadImageByS3 upload');
      uploadInstance.upload();
    });
  });
}

function uploadImageByVenus(files: File[], options: IUploadOptions): Promise<string> {
  const env = getEnv();
  const { path, bucket, } = options;
  console.log('123 uploadImageByVenus start', files);
  const signatureUrl = `/api/v1/fpmigrate/image/sign${bucket ? `?bucketName=${bucket}` : ''}`;
  return new Promise((resolve, reject) => {
    invokeUploadWithInterval(() => {
      const uploadInstance = createUpload({
        // signatureFunc: async () => {
        //   try {
        //     const params: any = { path, bucketName: bucket };
        //     const result = await getVenusSign(params);
        //     const {
        //       awsaccessKeyId, policy, signature, key
        //     } = result?.data || {};
        //     return {
        //       code: 0,
        //       message: 'success',
        //       data: {
        //         AWSAccessKeyId: awsaccessKeyId,
        //         policy,
        //         signature,
        //         key,
        //       },
        //     };
        //   } catch (error) {
        //     console.log(error);
        //     reject();
        //     // reportRaptor('【function】uploadInstance error', { error }, 'warn', 'customError');
        //     return null;
        //   }
        // },
        signatureUrl,
        clientId: isTestEnv() ? '82hkdn425qs2bxqt000000000071cbab' : 'pmcxkzm42l7nb2xs00000000002d62c0',
        isTest: isTestEnv(),
        authType: 'BAToken',
        // authType: 'muc',
        isHttps: true,
        multiple: false,
        networkEnv: 'public',
        bucket: bucket || 'user-upload-image',
        prefix_type: 's3_style',
        files,
        accept: ['png', 'jpg', 'jpeg'],
        venusHost: process_env_venusUploadHost,
        hashMode: true,
        // 临时，测试环境PC上传，先改为 false
        // exactKey: isTest ? false : true, // 上传的时候，不会带 . 和文件后缀名
        exactKey: true, // 上传的时候，不会带 . 和文件后缀名
        onStart(info: string) {
          console.log('123 imageuploadStart', info);
        },
        onFinish(fileUrls: any) {
          console.log('123 imageupload onFinish', fileUrls);
          // fileUrls.map((pic: any) => pic.originalLink)
          resolve(fileUrls?.map((pic: any) => ({ picUrl: pic.originalLink })) || []);
        },
        onProgress(percent: any) {
          console.log('123 onProgress', percent);
        },
        onError(errorMsg: string) {
          console.log('imageupload onError', errorMsg);
          reject(new Error(errorMsg));
        },
      }, 'venus'); // 值为1，单文件普通上传；值为2，单文件分片上传；值为3，多文件普通上传；值为venus，上传Venus
      console.log('123 uploadImageByVenus upload');
      uploadInstance.upload();
    });
  });
}

function createImageLocalUrl(file: File) {
  const URL = window.URL || window.webkitURL;
  const imgURL = URL && URL.createObjectURL(file);
  return imgURL || '';
}

export async function chooseImages(options: IUploadOptions = {}) {
  const { count = 9, type } = options;
  try {
    console.log('123 chooseImageFn start');
    // @ts-ignore
    const files: { file: File; }[] = await chooseImage({
      maxWidth: 900,
      maxHeight: 1600,
      quality: 60,
      count,
      // type: 'gallery',
      // sizeType: ['compressed'],
    });
    console.log('123 chooseImageFn end');

    if (Object.prototype.toString.call(files) === '[object Array]' && !files.length) {
      // 这种情况大多为用户取消选择图片，只做 info 上报
      // reportRaptor(`${EnumErrorType.Business}-choose-image-cancel`, { info: files }, 'warn', 'customError');
      return [];
    }
    return files;
    // return files.map((it) => {
    //   console.log(it);
    //   return {
    //     ...it,
    //   };
    // });
  } catch (error) {
    // reportRaptor(
    //   `${EnumErrorType.Business}-chooseImage-error`,
    //   { errorInfo: { error }, api: 'csb.chooseImage' },
    //   'warn',
    //   'customError'
    // );
    console.log('123 chooseImages error', error);
    return Promise.reject(error);
  }
}

export async function uploadImages(options: IUploadOptions = {}): Promise<IUploadInfo[]> {
  const { localIds, count = 9, type } = options;
  try {
    const resultList: IUploadInfo[] = [];

    localIds?.forEach((file) => {
      // console.log('-file.file-', file);
      // const upload = () => uploadImageByS3(file.file, options);
      const upload = () => uploadImageByVenus([file.file], options);
      resultList.push({
        url: createImageLocalUrl(file.origin),
        uploadPromise: upload(),
        reUpload: upload,
      });
    });

    // pc 上无法限制实际图片数
    return resultList.slice(0, count);
  } catch (error) {
    // reportRaptor(
    //   `${EnumErrorType.Business}-chooseImage-error`,
    //   { errorInfo: { error }, api: 'csb.chooseImage' },
    //   'warn',
    //   'customError'
    // );
    console.log('uploadImages error', error);
    return Promise.reject(error);
  }
}
